import React, { useState } from "react";
import { Calendar, ChevronRight } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import FindCaseStepper from "../../components/crm/FindCaseStepper";
import { Field, SelectShell, inputStyles, selectStyles } from "../../components/crm/formControls";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ncltPost, ncltGet } from "../../services/ncltApi";

import SelectMenu from "../../components/crm/SelectMenu";
// Short, true tips for the NCLT search footer.
const SEARCH_TIPS = [
  "Filing Number must be 16 digits",
  "Party & Advocate search need a Zonal Bench",
  "Case data available from 2006",
];

function NcltCases() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("");
  const [formData, setFormData] = useState({
    benchName: "",
    caseType: "",
    caseNumber: "",
    caseYear: "",
    filingNo: "",
    partyType: "",
    partyName: "",
    caseStatus: "",
    advocateName: "",
    cinNumber: "",
    barCouncilNo: "",
    searchType: "E",
    partySearchType: "E",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const typeOptions = [
    "CIN Number",
    "Filing Number",
    "Case Number",
    "Party Name",
    "Advocate Name",
  ];

const benchOptions = [
  { label: "Ahmedabad", value: "1" },
  { label: "Allahabad", value: "2" },
  { label: "Bengaluru", value: "3" },
  { label: "Chandigarh", value: "4" },
  { label: "Chennai", value: "5" },
  { label: "Guwahati", value: "6" },
  { label: "Hyderabad", value: "7" },
  { label: "Kolkata", value: "8" },
  { label: "Mumbai", value: "9" },
  { label: "New Delhi", value: "10" },
  { label: "Jaipur", value: "11" },
  { label: "Amaravati", value: "12" },
  { label: "Cuttack", value: "13" },
  { label: "Kochi", value: "14" },
  { label: "Indore", value: "15" },
];



  const caseTypeOptions = [
  { label: "Transfer Petition (Company Act)", value: "1" },
  { label: "Company Petition (Company Act)", value: "2" },
  { label: "Rehabilitation Petition (Company Act)", value: "3" },
  { label: "Interlocutory Application (Company Act)", value: "4" },
  { label: "Review Application (Company Act)", value: "5" },
  { label: "Restoration Application (Company Act)", value: "6" },
  { label: "Intervention Petition (Company Act)", value: "7" },
  { label: "Cross Application (Company Act)", value: "8" },
  { label: "Contempt Petition (Company Act)", value: "9" },
  { label: "Miscellaneous Application (Company Act)", value: "10" },
  { label: "Company Appeal (Company Act)", value: "11" },
  { label: "Cross Appeal (Company Act)", value: "12" },
  { label: "Company Application (Company Act)", value: "13" },
  { label: "CA(A) Merger & Amalgamation (Company Act)", value: "14" },
  { label: "CP(AA) Merger & Amalgamation (Company Act)", value: "15" },

  { label: "Company Petition IB (IBC)", value: "16" },
  { label: "Company Application (IBC)", value: "17" },
  { label: "Rehabilitation Petition (IBC)", value: "18" },
  { label: "Interlocutory Application (IBC)", value: "19" },
  { label: "Review Application (IBC)", value: "20" },
  { label: "Restoration Application (IBC)", value: "21" },
  { label: "Intervention Petition (IBC)", value: "22" },
  { label: "Cross Application (IBC)", value: "23" },
  { label: "Contempt Petition (IBC)", value: "24" },
  { label: "Miscellaneous Application (IBC)", value: "25" },
  { label: "Company Appeal (IBC)", value: "26" },
  { label: "Cross Appeal (IBC)", value: "27" },
  { label: "Transfer Petition (IBC)", value: "28" },

  { label: "Execution Petition (Company Act)", value: "29" },
  { label: "Interlocutory Application (IBC)", value: "30" },
  { label: "Transfer Application (Company Act)", value: "31" },
  { label: "Insolvency & Bankruptcy (Pre-Packaged)", value: "33" },
  { label: "Transfer Application (IBC)", value: "34" },
  { label: "Voluntary Liquidation (IBC)", value: "35" },
  { label: "Restored Company Petition (IBC)", value: "36" },
  { label: "Restored Company Petition (Companies Act)", value: "37" },
  { label: "Interlocutory Application (IBC) (Plan)", value: "38" },
  { label: "Interlocutory Application (IBC) (Liq.)", value: "39" },
  { label: "Interlocutory Application (IBC) (Dis.)", value: "40" },
  { label: "IA (Liq.) Progress Report (IBC)", value: "41" },
  { label: "Rule 63 Appeal", value: "42" }
];


  const partyTypeOptions = [
  { label: "All", value: "0" },
  { label: "Petitioner", value: "P" },
  { label: "Respondent", value: "R" },
];

  const caseStatusOptions = [
    { label: "All", value: "0" },
    { label: "Pending", value: "P" },
    { label: "Disposed", value: "D" },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleReset = () => {
    setSelectedType("");
    setFormData({
      benchName: "",
      caseType: "",
      caseNumber: "",
      caseYear: "",
      filingNo: "",
      partyType: "",
      partyName: "",
      caseStatus: "",
      advocateName: "",
      cinNumber: "",
      barCouncilNo: "",
      searchType: "E",
      partySearchType: "E",
    });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Clear any previous errors
    setLoading(true);

    let payload = {};
    let endpoint = "";
    let fetchMethod = "POST";

    switch (selectedType) {
  case "CIN Number":
    if (!formData.cinNumber.trim()) {
      setError("CIN Number is mandatory");
      setLoading(false);
      return;
    }
    payload = { cin: formData.cinNumber.trim() };
    endpoint = "/cin";
    break;

  case "Filing Number":
    if (!formData.filingNo.trim()) {
      setError("Filing Number is mandatory");
      setLoading(false);
      return;
    }
    if (!/^\d{16}$/.test(formData.filingNo)) {
      setError("Filing Number must be exactly 16 digits (as per NCLT)");
      setLoading(false);
      return;
    }
    fetchMethod = "GET";
    endpoint = `/filing/${formData.filingNo.trim()}`;
    break;

  case "Case Number":
    if (
      !formData.benchName ||
      !formData.caseType ||
      !formData.caseNumber ||
      !formData.caseYear
    ) {
      setError("All fields are mandatory for Case Number search");
      setLoading(false);
      return;
    }
    payload = {
      bench_id: formData.benchName,
      case_type_id: formData.caseType,
      case_no: formData.caseNumber.trim(),
      case_year: formData.caseYear,
    };
    endpoint = "/case-number";
    break;

  case "Party Name":
    if (
      !formData.benchName ||
      !formData.partyName.trim() ||
      !formData.caseYear
    ) {
      setError("Zonal Bench, Party Name and Case Year are mandatory");
      setLoading(false);
      return;
    }
    payload = {
      bench_id: formData.benchName,
      party_name: formData.partyName.trim(),
      case_year: formData.caseYear,
      party_type: formData.partyType || "0",
      case_status: formData.caseStatus || "0",
      search_type: formData.partySearchType,
    };
    endpoint = "/party";
    break;

  case "Advocate Name":
    if (
      !formData.benchName ||
      !formData.advocateName.trim() ||
      !formData.caseYear
    ) {
      setError("Zonal Bench, Advocate Name and Case Year are mandatory");
      setLoading(false);
      return;
    }
    payload = {
      bench_id: formData.benchName,
      advocate_name: formData.advocateName.trim(),
      case_year: formData.caseYear,
      search_type: formData.searchType,
      bar_council_number: formData.barCouncilNo.trim(),
    };
    endpoint = "/advocate-name";
    break;

  default:
    setError("Please select a search type");
    setLoading(false);
    return;
}

    try {

const fetchPromise = fetchMethod === "GET"
  ? ncltGet(endpoint)
  : ncltPost(endpoint, payload);

      const [response] = await Promise.all([
        fetchPromise,
        new Promise(resolve => setTimeout(resolve, 1500)) // Minimum 1.5 second loading
      ]);

      // Handle 404 or other HTTP errors
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error("No cases found matching your search criteria");
        }
        throw new Error(`Failed to fetch data: ${response.status}`);
      }

const result = response.body;

if (!result) {
  throw new Error("No cases found matching your search criteria");
}

setLoading(false);

if (selectedType === "Filing Number") {
  if (!result.header) {
    throw new Error("No cases found matching your search criteria");
  }
  navigate("/portal/ncltCaseFullDetails", {
    state: {
      caseData: result,
    },
  });
} else if (selectedType === "CIN Number") {
  const cinRows = result.byCinNumber || [];
  if (cinRows.length === 0) {
    throw new Error("No cases found matching your search criteria");
  }
  const mapped = cinRows.map((r) => ({
    filingNo: r.filing_no,
    caseNo: r.case_no,
    caseType: r.case_type_desc_cis,
    caseTitle1: r.case_title1,
    caseTitle2: r.case_title2,
    benchLocation: r.bench_location_name,
    courtNo: r.court_no,
    filingDate: r.date_of_filing,
    registrationDate: r.regis_date,
    nextListingDate: r.next_list_date,
    disposalDate: r.disposal_date,
    status: r.case_status === "P" ? "Pending" : r.case_status === "D" ? "Disposed" : r.case_status,
    caseStage: r.case_status === "P" ? "Pending" : r.case_status === "D" ? "Disposed" : r.case_status,
  }));
  navigate("/portal/ncltCaseDetails", {
    state: {
      data: mapped,
      searchParams: payload,
      searchType: selectedType,
      page: 1,
      hasNext: false,
    },
  });
} else {
  const cases = result.results || result.data || result;
  const caseArray = Array.isArray(cases) ? cases : [cases];
  if (caseArray.length === 0) {
    throw new Error("No cases found matching your search criteria");
  }
  navigate("/portal/ncltCaseDetails", {
    state: {
      data: caseArray,
      searchParams: payload,
      searchType: selectedType,
      page: result.page || 1,
      hasNext: result.hasNext || false,
    },
  });
}


    } catch (err) {
      // Set error and stop loading, but stay on the same page
      setError(err.message || "An error occurred while searching. Please try again.");
      setLoading(false);
      // Scroll to top to show error message
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Year-picker field reused by Case Number / Party Name / Advocate Name.
  const renderCaseYearField = () => (
    <Field label="Case Year">
      <div className="relative">
        <DatePicker
          selected={formData.caseYear ? new Date(formData.caseYear, 0, 1) : null}
          onChange={(date) => {
            if (date) {
              setFormData((prev) => ({ ...prev, caseYear: date.getFullYear().toString() }));
            }
          }}
          showYearPicker
          dateFormat="yyyy"
          maxDate={new Date()}
          minDate={new Date(2006, 0, 1)}
          placeholderText="Select Year"
          wrapperClassName="w-full"
          customInput={<input type="text" className={`${inputStyles} pr-9`} />}
        />
        <Calendar className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      </div>
    </Field>
  );

  // Exact / Wrap search-type radio group (Party Name + Advocate Name).
  const renderSearchTypeField = (name) => (
    <Field label="Search Type" required={false} className="sm:col-span-2">
      <div className="flex h-10 flex-wrap items-center gap-4">
        <label className="flex cursor-pointer items-center gap-1.5 text-sm text-slate-700">
          <input
            type="radio"
            name={name}
            value="E"
            checked={formData[name] === "E"}
            onChange={handleInputChange}
            className="accent-yellow-500"
          />
          Exact Search
        </label>
        <label className="flex cursor-pointer items-center gap-1.5 text-sm text-slate-700">
          <input
            type="radio"
            name={name}
            value="W"
            checked={formData[name] === "W"}
            onChange={handleInputChange}
            className="accent-yellow-500"
          />
          Wrap Search
        </label>
      </div>
    </Field>
  );

  const renderFields = () => {
    switch (selectedType) {
      case "CIN Number":
        return (
          <Field label="CIN Number" className="sm:col-span-2">
            <input
              name="cinNumber"
              value={formData.cinNumber}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter CIN Number (e.g. U40101TN2007GAT063283)"
              className={inputStyles}
            />
          </Field>
        );

      case "Filing Number":
        return (
          <Field label="Filing Number" className="sm:col-span-2">
            <input
              name="filingNo"
              value={formData.filingNo}
              onChange={handleInputChange}
              maxLength={16}
              inputMode="numeric"
              placeholder="Enter 16-digit Filing Number"
              className={inputStyles}
            />
          </Field>
        );

      case "Case Number":
        return (
          <>
            <Field label="Zonal Bench">
              <SelectShell>
                <SelectMenu chevron={false} name="benchName" value={formData.benchName} onChange={handleInputChange} className={selectStyles}>
                  <option value="">Select Bench Name</option>
                  {benchOptions.map((bench) => (
                    <option key={bench.value} value={bench.value}>{bench.label}</option>
                  ))}
                </SelectMenu>
              </SelectShell>
            </Field>
            <Field label="Case Type">
              <SelectShell>
                <SelectMenu chevron={false} name="caseType" value={formData.caseType} onChange={handleInputChange} className={selectStyles}>
                  <option value="">Select Case Type</option>
                  {caseTypeOptions.map((type) => (
                    <option key={type.value} value={type.value}>{type.label}</option>
                  ))}
                </SelectMenu>
              </SelectShell>
            </Field>
            <Field label="Case Number">
              <input
                name="caseNumber"
                value={formData.caseNumber}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter Case Number"
                className={inputStyles}
              />
            </Field>
            {renderCaseYearField()}
          </>
        );

      case "Party Name":
        return (
          <>
            {renderSearchTypeField("partySearchType")}
            <Field label="Zonal Bench">
              <SelectShell>
                <SelectMenu chevron={false} name="benchName" value={formData.benchName} onChange={handleInputChange} className={selectStyles}>
                  <option value="">Select Bench Name</option>
                  {benchOptions.map((bench) => (
                    <option key={bench.value} value={bench.value}>{bench.label}</option>
                  ))}
                </SelectMenu>
              </SelectShell>
            </Field>
            <Field label="Party Type" required={false}>
              <SelectShell>
                <SelectMenu chevron={false} name="partyType" value={formData.partyType} onChange={handleInputChange} className={selectStyles}>
                  {partyTypeOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </SelectMenu>
              </SelectShell>
            </Field>
            <Field label="Party Name">
              <input
                name="partyName"
                value={formData.partyName}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter Party Name"
                className={inputStyles}
              />
            </Field>
            {renderCaseYearField()}
            <Field label="Case Status" required={false}>
              <SelectShell>
                <SelectMenu chevron={false} name="caseStatus" value={formData.caseStatus} onChange={handleInputChange} className={selectStyles}>
                  {caseStatusOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </SelectMenu>
              </SelectShell>
            </Field>
          </>
        );

      case "Advocate Name":
        return (
          <>
            {renderSearchTypeField("searchType")}
            <Field label="Zonal Bench">
              <SelectShell>
                <SelectMenu chevron={false} name="benchName" value={formData.benchName} onChange={handleInputChange} className={selectStyles}>
                  <option value="">Select Bench Name</option>
                  {benchOptions.map((bench) => (
                    <option key={bench.value} value={bench.value}>{bench.label}</option>
                  ))}
                </SelectMenu>
              </SelectShell>
            </Field>
            <Field label="Advocate Name">
              <input
                name="advocateName"
                value={formData.advocateName}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter Advocate Name"
                className={inputStyles}
              />
            </Field>
            <Field label="Bar Council Number" required={false}>
              <input
                name="barCouncilNo"
                value={formData.barCouncilNo}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter Bar Council No."
                className={inputStyles}
              />
            </Field>
            {renderCaseYearField()}
          </>
        );

      default:
        return null;
    }
  };

  // Full page skeleton loader
  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8FAFC]">
        <main className="px-4 sm:px-6 lg:px-8 py-4">
            <SkeletonTheme
  baseColor="#e2e8f0"
  highlightColor="#f1f5f9"
>
              {/* Header Skeleton */}
              <div className="relative z-10 grid grid-cols-2 items-center p-4">
                <div className="flex items-center md:ml-12">
                  <Skeleton width={24} height={24} />
                  <Skeleton width={250} height={36} className="ml-4" />
                </div>
              </div>

              {/* Main Content Skeleton */}
              <div className="mt-4 flex items-start justify-center">
                <div className="p-5 w-full max-w-3xl rounded-2xl bg-white border border-slate-200 shadow-sm text-slate-800">
                  {/* Loading Message */}
                  <div className="text-center mb-6">
                    <div className="flex justify-center items-center space-x-3">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-500"></div>
                      <span className="text-yellow-500 text-lg font-semibold animate-pulse">
                        Fetching cases, Please wait until magic happens.
                      </span>
                    </div>
                  </div>

                  {/* Form Fields Skeleton */}
                  <div className="mb-4">
                    <Skeleton width={120} height={20} className="mb-2" />
                    <Skeleton height={40} className="rounded w-full" />
                  </div>

                  {/* Dynamic Fields Skeleton based on selectedType */}
                  <div className="space-y-4">
                    {selectedType === "CIN Number" && (
                      <div className="mb-4">
                        <Skeleton width={150} height={20} className="mb-2" />
                        <Skeleton height={40} className="rounded w-full" />
                      </div>
                    )}
                    {selectedType === "Filing Number" && (
                      <div className="mb-4">
                        <Skeleton width={150} height={20} className="mb-2" />
                        <Skeleton height={40} className="rounded w-full" />
                      </div>
                    )}
                    {selectedType === "Case Number" && (
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                        {[1, 2, 3, 4].map((i) => (
                          <div key={i}>
                            <Skeleton width={100} height={20} className="mb-2" />
                            <Skeleton height={40} className="rounded w-full" />
                          </div>
                        ))}
                      </div>
                    )}
                    {selectedType === "Party Name" && (
                      <>
                        <div className="mb-4">
                          <Skeleton width={100} height={20} className="mb-2" />
                          <div className="flex space-x-4">
                            <Skeleton width={120} height={20} />
                            <Skeleton width={120} height={20} />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
                          {[1, 2, 3, 4, 5].map((i) => (
                            <div key={i}>
                              <Skeleton width={100} height={20} className="mb-2" />
                              <Skeleton height={40} className="rounded w-full" />
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                    {selectedType === "Advocate Name" && (
                      <>
                        <div className="mb-4">
                          <Skeleton width={100} height={20} className="mb-2" />
                          <div className="flex space-x-4">
                            <Skeleton width={120} height={20} />
                            <Skeleton width={120} height={20} />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                          {[1, 2, 3, 4].map((i) => (
                            <div key={i}>
                              <Skeleton width={100} height={20} className="mb-2" />
                              <Skeleton height={40} className="rounded w-full" />
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>

                  {/* Buttons Skeleton */}
                  <div className="mt-6 flex justify-between">
                    <Skeleton width={120} height={40} className="rounded" />
                    <Skeleton width={100} height={40} className="rounded" />
                  </div>
                </div>
              </div>
            </SkeletonTheme>
        </main>
      </div>
    );
  }

  // Normal page render
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <main className="px-4 sm:px-6 lg:px-8 py-4">
        {/* Breadcrumb */}
        <div className="flex items-center gap-1.5 text-sm">
          <Link to="/portal/findCasesOptions" className="text-slate-500 hover:text-slate-800">Find Cases</Link>
          <ChevronRight className="h-4 w-4 text-slate-400" />
          <span className="font-medium text-slate-800">NCLT</span>
        </div>

        {/* Stepper */}
        <div className="mt-4"><FindCaseStepper current={2} /></div>

        {/* Form Card — full width */}
        <div className="mt-4 w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
          <form onSubmit={handleSubmit}>
            <div className="p-5 sm:p-6">
              {/* Search By pills */}
              <p className="mb-2 text-center text-xs font-medium text-slate-600">Search By</p>
              <div className="flex flex-wrap justify-center gap-2">
                {typeOptions.map((opt) => (
                  <button
                    key={opt}
                    type="button"
                    onClick={() => {
                      setSelectedType(opt);
                      setError("");
                    }}
                    className={`rounded-full px-4 py-1.5 text-[13px] font-medium transition-all duration-200 ${
                      selectedType === opt
                        ? "bg-yellow-500 text-slate-900 shadow-sm"
                        : "border border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50"
                    }`}
                  >
                    {opt}
                  </button>
                ))}
              </div>

              {selectedType ? (
                <>
                  <h2 className="mt-6 text-sm font-semibold text-slate-800">
                    NCLT : Search by {selectedType}
                  </h2>

                  {error && (
                    <p className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600 ring-1 ring-red-100">
                      {error}
                    </p>
                  )}

                  <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
                    {renderFields()}
                  </div>
                </>
              ) : (
                <>
                  {error && (
                    <p className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600 ring-1 ring-red-100">
                      {error}
                    </p>
                  )}
                  <p className="mt-6 text-center text-sm text-slate-500">
                    Select a search type above to begin.
                  </p>
                </>
              )}
            </div>

            {/* Footer — tips + actions */}
            <div className="flex flex-col gap-4 border-t border-slate-100 bg-slate-50/60 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
              <ul className="flex flex-wrap items-center gap-x-5 gap-y-1">
                {SEARCH_TIPS.map((tip) => (
                  <li key={tip} className="flex items-center gap-1.5 text-xs text-slate-500">
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-yellow-400" />
                    {tip}
                  </li>
                ))}
              </ul>
              <div className="flex shrink-0 gap-3">
                <button
                  type="button"
                  onClick={handleReset}
                  className="h-10 rounded-lg border border-slate-300 bg-white px-6 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-50 disabled:opacity-60"
                  disabled={loading}
                >
                  Reset
                </button>
                <button
                  type="submit"
                  className="h-10 rounded-lg bg-yellow-500 px-8 text-sm font-semibold text-slate-900 transition-colors hover:bg-yellow-400 disabled:cursor-not-allowed disabled:opacity-60"
                  disabled={!selectedType}
                >
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}

export default NcltCases;
